import { gql } from '@apollo/client';

export const EntityCategoryFragment = gql`
  fragment EntityCategoryFields on EntityCategory {
    id
    name
    color
    isEmpty
    schema {
      id
      name
    }
  }
`;
